import { CheckCircleIcon, CutReceiptIcon, DotCalendarIcon, FrontCarIcon, GearIcon, LicenceIcon, RoadIcon, SideCarIcon, VerifiedPersonIcon } from "../icons";

export const ENV_VARIABLES = {
  baseUrl: process.env.REACT_APP_BASE_URL,
};

export const QUERY_KEYS = {
  USERS: "Users",
  USER_ROLES: "User_Roles",
  USER_LIST: "User_List",
  ADD_USER_FORM_FILEDS: "Add_User_From_Fields",
  EDIT_USER_FORM_FIELDS: "Edit_User_From_Fields",
  USER_TYPES: "User_Type",
  IMPERSONATE_USER: "Impersonate_User",
  REPORTS_FIELDS: "REPORTS_FIELDS",
  DRIVERS: "Drivers",
  ASSIGN_DRIVERS: "ASSIGN_DRIVERS",
  CREATE_DRIVER: "Create_Driver",
  EXPORT_DRIVERS: "Export_Drivers",
  MULTIPLE_UPLOAD_LIST: "Multiple_Upload_List",
  MULTIPLE_UPLOAD_REPORTS: "Multiple_Upload_Reports",
  BOOKING_REPORTINGS: "Booking_Reportings",
  BOOKING_STATISTICS: "Booking_Statistics",
  OFFER_REPORTING: "Offer_Reporting",
  DOWNLOAD_LOGS: "Download_Logs",
  DOWNLOAD_LOGS_DOCUMENT: "Download_Logs_Document",
  OFFER_LIST: "Offer_List",
  OFFER_DETAILS: "Offer_Details",
  CARS: "Cars",
  SIDEBAR_ITEMS: "sidebaritems",
  ORDERS: "Orders",
  INVOICES: "Invoices",
  IMPORT_TEMPLATE: "Import_Template",
  NOTIFICATIONS: "Notifications",
  COMPANY_GROUPS: "companygroups",
  COMPANY_GROUPS_FIELDS: "group_Fields",
  COMPANY_GROUPS_EDITABLE_FIELDS: "group_edit_Fields",
  COMPANY_GROUPS_DETAILS: "group_details",
  IMPERSONATE_FLEET_ADMIN: "Impersonate_fleet_admin",
  SERVICE_HISTORY: "service_history",
  SERVICE_CREATE_INPUTS: "create_booking_inputs",
  SERVICE_FLOW_ID: "service_flow_id",
  VEHICLE_DELIVERY_CREATE_INPUTS: "create_vehicle_delivery_inputs",
  VEHICLE_DELIVERY_FLOW_ID: "vehicle_delivery_flow_id",
  VEHICLE_DELIVERY_INFO: "deliveryInfo",
  DOCUMENT_CATEGORIES: "document_categories",
  CATEGORY_DOCS: "category_of_documents",
  DOCUMENT: "document",
};

export const PAGES = {
  USERS: 'Users',
  ROLES: 'Roles',
  REPORTS: 'Reports',
  INVOICES: 'Invoice',
  IMPORT_DRIVERS: 'Import Drivers',
  MY_CAR: 'My Car',
  DOWNLOAD_LOGS: 'Download Logs',
  OFFER_CHECK: 'Offers Check',
  OFFERS_REPORTING: 'Offers Reporting',
  BOOKING_REPORTS: 'Booking Reporting',
  TRACK_YOUR_CAR: 'Track Your Car',
  GROUP_OF_COMPANIES: 'Company Groups',
  LOYALTY:"Loyalty Program",
  DOCUMENTS: 'Documents',
};

export const ROLESLIST = {
  CONTRACTCENTER: "contactCenter",
  FLEETADMIN: "fleetadmin",
  REPORTSADMIN: "reportadmin",
  ADMIN: "admin",
  DOCADMIN: "docadmin",
  GROUPFLEETADMIN: "groupfleetadmin",
};

export const SERVICE_BOOKING_STEPS = {
  "workSelection": 1,
  "location": 2,
  "optionSelection": 3,
  "pickupDeliveryAddress": 4,
  "booking": 5,
  "formForCRM": 6,
  "tyreChange": 7,
  "bodyWork": 8,
  "additionalComments": 9
}

export const DELIVERY_BOOKING_STEPS = {
  "optionSelection": 1,
  "deliveryAddress": 2,
  "booking": 3,
  "additionalComments": 4,
}


export const orderSteps = [
  {
    step: 1,
    title: "Υποβολή παραγγελίας",
    subtitle: "Η παραγγελία σου έχει σταλεί στον προμηθευτή και αναμένουμε επιβεβαίωση.",
    caption: "",
    icon: <CutReceiptIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 2,
    title: "Επιβεβαίωση παραγγελίας",
    subtitle: "Ο προμηθευτής επιβεβαίωσε την παραγγελία και αναμένεται να προγραμματιστεί η παραγωγή του αυτοκινήτου.",
    caption: "Εκτιμώμενη παράδοση:",
    icon: <VerifiedPersonIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 3,
    title: "Σε παραγωγή",
    subtitle: "Η παραγωγή του αυτοκινήτου σου έχει ξεκινήσει.",
    caption: "Εκτιμώμενη παράδοση:",
    icon: <GearIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 4,
    title: "Σε μεταφορά",
    subtitle: "Το αυτοκίνητό σου μεταφέρεται προς την Ελλάδα.",
    caption: "Εκτιμώμενη παράδοση:",
    icon: <RoadIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 5,
    title: "Άφιξη στο τελωνείο",
    subtitle: "Το αυτοκίνητό σου βρίσκεται σε διαδικασία εκτελωνισμού.",
    caption: "Εκτιμώμενη παράδοση:",
    icon: <SideCarIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 6,
    title: "Έκδοση πινακίδων",
    subtitle: "Έχουν εκδοθεί οι πινακίδες κυκλοφορίας.",
    caption: "Εκτιμώμενη παράδοση:",
    icon: <LicenceIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 7,
    title: "Διαθέσιμο για παραλαβή",
    subtitle: "Όρισε τον κύριο οδηγό και προγραμμάτισε το ραντεβού για την παραλαβή του αυτοκινήτου σου.",
    caption: "Παραλαβή από:",
    icon: <FrontCarIcon className='w-[34px] h-[34px]' />,
  },
  {
    step: 8,
    title: "Προγραμματισμός παραλαβής",
    subtitle: "Έχεις προγραμματίσει την παραλαβή του αυτοκινήτου σου για τις ",
    caption: "",
    icon: <DotCalendarIcon className='w-[34px] h-[34px]' />,
  },
];

export const cfmsCodesOrderTracking = {
  "1001": 1,
  "1002": 1,
  "1003": 1,
  "1004": 1,
  "1005": 6,
  "1006": 7,
  "1007": 9,
  "1009": 1,
  "1010": 2,
  "1011": 3,
  "1012": 4,
  "1013": 5,
}
export const imageStudioBaseUrl =
  "https://cdn.imagin.studio/getImage?customer=avis-gr";

export const myAvisUrl = "https://www.myavis.gr/el";


export const notificationsIcons = (notification) => {
  switch(notification?.type) {
    case "vote":
      return {
        headIcon: <CheckCircleIcon className={'w-6 h-6 stroke-[#2E9BFF] shrink-0'} />,
        leadIcon: "" 
      }
    case "service-booking":
      return {
        headIcon: <CheckCircleIcon className={'w-6 h-6 stroke-[#2E9BFF] shrink-0'} />,
        leadIcon: "" 
      }    
    case "new-arrival":
      return {
        headIcon: <CheckCircleIcon className={'w-6 h-6 stroke-[#2E9BFF] shrink-0'} />,
        leadIcon: "" 
      }
    case "booking-update":
      return {
        headIcon: <CheckCircleIcon className={'w-6 h-6 stroke-[#2E9BFF] shrink-0'} />,
        leadIcon: "" 
      }
    case "action-required":
      return {
        headIcon: <CheckCircleIcon className={'w-6 h-6 stroke-[#2E9BFF] shrink-0'} />,
        leadIcon: "" 
      }
    default:
      return {
        headIcon: <CheckCircleIcon className={'w-6 h-6 stroke-[#2E9BFF] shrink-0'} />,
        leadIcon: "🔔" 
      }
  }
}